import { Container, Row, Navbar, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { LinkContainer } from "react-router-bootstrap";


import routersJson from 'data/routers.json';

import { serviceUrlList } from "server";

const PortalFooter = () => {

  const { t, i18n } = useTranslation("portal");

  // ==========友情链接==========

  const [links, setLinks] = useState([]);


  // 友情链接
  // useEffect(() => {

  //   const loadLinks = async () => {

  //     const res = await serviceUrlList();

  //     if (res?.code === 200) {

  //       const filterUrls = [
  //         "https://biovisart.com/",
  //         "http://192.168.31.212:4000/",
  //       ];

  //       setLinks(
  //         (res.data || []).filter(
  //           (item) => !filterUrls.includes(item.serviceUrl)
  //         )
  //       );
  //     }
  //   };

  //   loadLinks();

  // }, []);

  return (
    <footer
      className="text-light py-4"
      style={{ backgroundColor: "#005fa3", }}
    >
      <Container>
        <Row className="align-items-center">
          <Col md={3} className="mb-4 mb-md-0 d-flex justify-content-center justify-content-md-start">
            <LinkContainer to="/home" >
              <Navbar.Brand>
                <img
                  src={`/img/biovis_sc.png`}
                  alt="Logo"
                  className="sanger-footer-logo"
                />
              </Navbar.Brand>
            </LinkContainer>
          </Col>

          <Col md={6} className="mb-4 mb-md-0">
            <div className="d-flex flex-wrap justify-content-center gap-3 mb-3">
              {/* 内部导航 */}
              {routersJson.map((item, index) => (
                <a
                  key={index}
                  href={item.path}
                  className="text-light text-decoration-none border-end pe-3 last-child-no-border"
                >
                  {t(item.label)}
                </a>
              ))}
            </div>

            <div className="d-flex flex-wrap justify-content-center gap-3">
              {links
                .filter(item => !["https://biovisart.com/", "http://192.168.31.212:4000/"].includes(item.serviceUrl))
                .map((item) => (
                  <a
                    key={item.id}
                    href={item.serviceUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="text-light text-decoration-none"
                    style={{ fontSize: '0.85rem', opacity: 0.7 }}
                  >
                    {i18n.language?.startsWith("zh") ? item.cnName : item.enName}
                  </a>
                ))}
            </div>
          </Col>

          <Col md={3} className="text-center text-md-start">
            <h2 className="mb-3">BioVis Platform</h2>
            <div className="mb-2">
              <span className="me-1">{t("email")}</span>
              <a
                href="mailto:shenwt1234@gmail.com"
                className="text-light text-decoration-none"
              >
                shenwt1234@gmail.com
              </a>
            </div>
          </Col>
        </Row>


        <Row>
          <Col className="text-center">
            <a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
              rel="noreferrer"
              className="beian-link-white"
            >
              浙ICP备2023007324号
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default PortalFooter;